module.exports = __webpack_public_path__ + "img/footer.8e25bf6a.svg";